import React from "react"
import BaseSvgIcon from "./Base"

const DownloadFile = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 64 64" stroke={props.stroke}>
      <g>
        <polygon
          fill="none"
          stroke={props.stroke ? props.stroke : "#000000"}
          strokeWidth="2"
          strokeMiterlimit="10"
          points="23,1 55,1 55,63 9,63 9,15 	"
        />
        <polyline
          fill="none"
          stroke={props.stroke ? props.stroke : "#000000"}
          strokeWidth="2"
          strokeMiterlimit="10"
          points="9,15 23,15 23,1 	"
        />
      </g>
      <polyline
        fill="none"
        stroke={props.stroke ? props.stroke : "#000000"}
        strokeWidth="2"
        strokeLinejoin="bevel"
        strokeMiterlimit="10"
        points="40,37 32,45 
        24,37 "
      />
      <g>
        <line
          fill="none"
          stroke={props.stroke ? props.stroke : "#000000"}
          strokeWidth="2"
          strokeMiterlimit="10"
          x1="32"
          y1="45"
          x2="32"
          y2="25"
        />
      </g>
    </BaseSvgIcon>
  )
}

export default DownloadFile
